import { render, staticRenderFns } from "./CadastroPrescricaoUso.vue?vue&type=template&id=619a5cec&"
import script from "./CadastroPrescricaoUso.vue?vue&type=script&lang=js&"
export * from "./CadastroPrescricaoUso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports